import React, { Component } from "react";
import { Button, Table, message, Tag, Steps, Modal } from "antd";
import { settleDetail, updateStatus, updateAmount } from "@api/settle";
import FormSummary from "@components/FormSummary";
import bus from "@utils/bus";
import moment from "moment";

const confirm = Modal.confirm;
const Step = Steps.Step;

const completeSteps = {
    0: {
        title: "未申请",
        content: "请核对账单明细后发起结算申请"
    },
    1: {
        title: "已申请",
        content: "已发起结算申请"
    },
    2: {
        title: "金额已确认",
        content: "已核对金额"
    },
    3: {
        title: "已审核",
        content: "结算申请已审核通过"
    },
    4: {
        title: "资料已确认",
        content: "资料已收到并确认无误"
    },
    5: {
        title: "已付款",
        content: "资料已收到并确认无误"
    }
};
const undoneSteps = {
    0: {
        title: "未申请",
        content: "请核对账单明细后发起结算申请"
    },
    1: {
        title: "已申请",
        content: "已发起结算申请"
    },
    2: {
        title: "确认金额",
        content: "请核对金额"
    },
    3: {
        title: "审核中",
        content: "请稍等, 正在成为您审核..."
    },
    4: {
        title: "资料邮寄",
        content: "请邮寄发票和本月明细并盖公章, 邮寄后请等待确认"
    },
    5: {
        title: "付款中",
        content: "请邮寄发票和本月明细并盖公章, 邮寄后请等待确认"
    }
};
const adminSteps = {
    0: {
        title: "未申请",
        content: "请核对账单明细后发起结算申请"
    },
    1: {
        title: "已申请",
        content: "已发起结算申请"
    },
    2: {
        title: "确认金额",
        content: "确认当月金额信息无误"
    },
    3: {
        title: "确认结算",
        content: "确认当月明细和开票信息无误"
    },
    4: {
        title: "确认资料",
        content: "确认收到的资料信息无误"
    },
    5: {
        title: "付款",
        content: "确认金额及账户信息无误并已打款"
    }
};

const dateFormat = "YYYY-MM";
const config = {
    0: { name: "待发申请结算", color: "#606266", border: '#DCDFE6', content: "申请结算" },
    1: { name: "待确认金额", color: "#606266", border: '#DCDFE6', content: "确认金额" },
    2: { name: "待确认结算", color: "#606266", border: '#DCDFE6', content: "确认结算" },
    3: { name: "待确认资料", color: "#606266", border: '#DCDFE6', content: "确认资料" },
    4: { name: "待进行付款", color: "#606266", border: '#DCDFE6', content: "付款" },
    5: { name: "已付款", color: "#67C23A", border: '#D3E7CE' }
};

export default class Settle extends Component {
    formRef = React.createRef();

    state = {
        pagination: {
            page: 1,
            size: 10,
            total: 0
        },
        visible: false,
        formItems: [
            {
                key: "income",
                label: "收入",
                require: true,
                componentName: "input",
                message: "收入必填"
            },
            {
                key: "divideIncome",
                label: "分成收入",
                require: true,
                componentName: "input",
                message: "分成收入必填"
            }
        ],
        formDefaultValue: {},
        tableData: [],
        partner: {},
        expandedRowKeys: []
    };

    componentWillMount() {
        this.getSettleDetail({ page: 1, size: 10 });
    }

    getChannelIdAndName = () => {
        let name = "",
            id = "";

        if (bus.userInfo.roleTp === 5) {
            name = bus.userInfo.secondLevelChannelNames[0];
            id = bus.userInfo.secondLevelChannelIds[0];
        } else {
            const params = this.props.history.location.search
                .slice(1)
                .split("&")
                .map(item => item.split("=")[1]);

            id = params[0];
            name = params[1];
        }

        return { name, id };
    };

    getSettleDetail = async params => {
        params.channelId = this.getChannelIdAndName().id;

        const res = await settleDetail(params);

        if (res.data.meta.errCode !== 0) {
            message.error(res.data.meta.errMsg);
            return;
        }

        const paging = res.data.meta.paging || {};

        this.setState({
            pagination: { ...paging },
            tableData: res.data.data.list || [],
            partner: res.data.data.partner || {}
        });
    };

    handleDateFormat = timestamp => {
        return timestamp
            ? moment(new Date(timestamp * 1000)).format(dateFormat)
            : "---";
    };

    changePage = page => {
        const params = {
            page: page.current,
            size: 10
        };
        this.getSettleDetail(params);
    };

    getCurrentStatus = status => {
        return <Tag style={{ cursor: 'default', background: '#fff', borderColor: config[status].border, color: config[status].color }} >{config[status].name}</Tag>;
    };

    btnIsShow = data => {
        if (bus.userInfo.roleTp === 5) {
            if (data.status === 0) {
                return "block";
            }
            return "none";
        } else {
            if (data.status === 5) {
                return "none";
            }
            return "block";
        }
    };

    btnIsDisabled = data => {
        const roleTp = bus.userInfo.roleTp;
        const status = data.status;

        if (roleTp === 5) {
            // 合作方, 发起申请
            return false;
        }
        if (status === 0) {
            return true;
        }
        if (roleTp === 1 || (roleTp === 2 && status === 1)) {
            return false;
        }
        if (
            (roleTp === 1 || roleTp === 3) &&
            (status === 2 || status === 3 || status === 4)
        ) {
            return false;
        }

        return true;
    };

    handleGoOn = async data => {
        let _this = this;

        confirm({
            title: `您确定进行 ${config[data.status].content} 操作嘛?`,
            content: "",
            onOk() {
                _this.handleUpdateStatus(data);
            }
        });
    };

    handleUpdateStatus = async data => {
        const status = data.status;
        const params = {
            status: status + 1,
            id: data.id
        };

        const res = await updateStatus(params);

        if (res.data.meta.errCode !== 0) {
            message.error(res.data.meta.errMsg);
            return;
        }

        message.success("提交成功!");
        this.getSettleDetail({ page: this.state.pagination.page, size: 10 });
    };

    amountBtnIsShow = data => {
        const roleTp = bus.userInfo.roleTp;
        const status = data.status;

        if (status > 1 && status < 5 && (roleTp === 1 || roleTp === 3)) {
            return "inline";
        }

        return "none";
    };

    handleCancle = () => {
        this.setState({ visible: false });
    };

    handleAmountOk = () => {
        let _this = this;

        confirm({
            title: `您确定进行修改金额嘛?`,
            content: "",
            onOk() {
                _this.updateAmount();
            }
        });
    };

    updateAmount = async () => {
        let form = this.formRef.current;

        try {
            const values = await form.validateFields();

            const params = {
                id: this.state.currentId,
                income: Number(values.income),
                divideIncome: Number(values.divideIncome)
            };

            const res = await updateAmount(params);
            if (res.data.meta.errCode !== 0) {
                message.error(res.data.meta.errMsg);
                return;
            }

            message.success("更新金额成功");
            this.setState({ visible: false });
            this.getSettleDetail({
                page: this.state.pagination.page,
                size: 10
            });
        } catch (err) {
            console.log(err);
        }
    };

    handleUpdateAmount = data => {
        this.setState({
            visible: true,
            currentId: data.id,
            formDefaultValue: {
                income: data.income,
                divideIncome: data.divideIncome
            }
        });
    };

    getRowDeatail = data => {
        let arr = [0, 1, 2, 3, 4, 5];

        if (data.status >= 1) {
            arr = [1, 2, 3, 4, 5];
        } else {
            arr = [0, 2, 3, 4, 5];
        }

        return (
            <div style={{ paddingTop: 8 }}>
                <Steps current={data.status} size="small">
                    {arr.map(item => {
                        let targetSteps = {};

                        if (item > data.status) {
                            targetSteps =
                                bus.userInfo.roleTp === 5
                                    ? undoneSteps
                                    : adminSteps;
                        } else {
                            targetSteps =
                                bus.userInfo.roleTp === 5
                                    ? completeSteps
                                    : adminSteps;
                        }

                        return (
                            <Step
                                key={item}
                                title={targetSteps[item].title}
                                description={targetSteps[item].content}
                            />
                        );
                    })}
                </Steps>
                <div
                    style={{
                        textAlign: "center",
                        marginTop: 20,
                        display: this.btnIsShow(data)
                    }}
                >
                    <Button
                        type="primary"
                        size="small"
                        disabled={this.btnIsDisabled(data)}
                        onClick={() => {
                            this.handleGoOn(data);
                        }}
                    >
                        下一步
                    </Button>
                    <Button
                        type="primary"
                        size="small"
                        style={{
                            marginLeft: 10,
                            display: this.amountBtnIsShow(data)
                        }}
                        onClick={() => {
                            this.handleUpdateAmount(data);
                        }}
                    >
                        修改金额
                    </Button>
                </div>
            </div>
        );
    };

    goToSettleContract = data => {
        this.props.history.push(
            `/contract?id=${data.id}&date=${this.handleDateFormat(data.month)
                .split("-")
                .join("")}`
        );
    };

    open = record => {
        const { id: key } = record;
        const filtered = this.state.expandedRowKeys;

        if (this.state.expandedRowKeys.includes(key)) {
            filtered.splice(filtered.findIndex(element => element === key), 1);
        } else {
            filtered.push(key);
        }

        this.setState({
            expandedRowKeys: filtered
        });
    };

    render() {
        const { expandedRowKeys, partner } = this.state;
        const type = partner.cooperateType;
        let tempItem = {};

        if (type === 'cps') {
            tempItem = {
                title: "收入(元)",
                dataIndex: "income",
                align: "center"
            }
        } else {
            tempItem = {
                title: "新用户量",
                dataIndex: "newUserNum",
                align: "center"
            }
        }

        const columns = [
            {
                title: "日期",
                dataIndex: "month",
                render: (text, record, index) => {
                    return <span>{this.handleDateFormat(text)}</span>;
                }
            },
            tempItem,
            {
                title: "分成收入(元)",
                dataIndex: "divideIncome",
                align: "center"
            },
            {
                title: "账单明细",
                dataIndex: "id",
                align: "center",
                render: (text, record, index) => (
                    <span
                        style={{ color: "#1890ff", cursor: "pointer" }}
                        onClick={() => {
                            this.goToSettleContract(record);
                        }}
                    >
                        账单明细
                    </span>
                )
            },
            {
                title: "状态",
                dataIndex: "status",
                align: "center",
                render: (text, record, index) => {
                    return this.getCurrentStatus(text);
                }
            },
            {
                title: "操作",
                dataIndex: "action",
                align: "center",
                render: (text, record, index) => {
                    return (
                        <Button
                            type="primary"
                            size="small"
                            onClick={() => {
                                this.open(record);
                            }}
                        >
                            { expandedRowKeys.includes(record.id) ? '收起' : '展开' }
                        </Button>
                    );
                }
            }
        ];

        return (
            <div>
                <h2 style={{ marginTop: 8 }}>
                    {this.getChannelIdAndName().name} 结算详情
                </h2>
                <div className="el-table el-table--border info-table-cont">
                    <div className="el-table__body-wrapper">
                        <table className="info-table">
                            <tbody>
                                <tr>
                                    <td className="table-title">账户名称</td>
                                    <td colSpan="3">
                                        {this.state.partner.bankAccountName ||
                                            "暂无"}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="table-title">联系地址</td>
                                    <td colSpan="3">
                                        {this.state.partner.address || "暂无"}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="table-title">联系人</td>
                                    <td>
                                        {this.state.partner.contact || "暂无"}
                                    </td>
                                    <td className="table-title">手机</td>
                                    <td>
                                        {this.state.partner.mobile || "暂无"}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="table-title">开票项目</td>
                                    <td>
                                        {this.state.partner.invoiceTp || "暂无"}
                                    </td>
                                    <td className="table-title">税号</td>
                                    <td>
                                        {this.state.partner.taxNumber || "暂无"}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="table-title">
                                        累计结算金额
                                    </td>
                                    <td colSpan="3">
                                        <div className="table-info-big">
                                            {this.state.partner
                                                .totalDivideIncome || "暂无"}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <Table
                    locale={{ emptyText: "暂无数据" }}
                    rowKey={item => item.id}
                    style={{ marginTop: 18 }}
                    columns={columns}
                    pagination={this.state.pagination}
                    rowClassName="hidden_icon"
                    expandedRowRender={record => {
                        return this.getRowDeatail(record);
                    }}
                    expandedRowKeys={expandedRowKeys}
                    dataSource={this.state.tableData}
                    expandRowByClick={true}
                />
                <Modal
                    destroyOnClose={true}
                    title="修改金额"
                    visible={this.state.visible}
                    onOk={this.handleAmountOk}
                    onCancel={this.handleCancle}
                    okText="确认"
                    cancelText="取消"
                >
                    <div>
                        <FormSummary
                            ref={this.formRef}
                            formItems={this.state.formItems}
                            formDefaultValue={this.state.formDefaultValue}
                        />
                    </div>
                </Modal>
            </div>
        );
    }
}
